import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const storageLocationFilterNames = ["name", "sku", "location"] as const;
export type StorageLocationFilterName =
  (typeof storageLocationFilterNames)[number];

export const getStorageLocationUniqueValues = {
  name: "getStorageLocationUniqueValues" as const,
  input: z.object({
    filterName: createEnum(storageLocationFilterNames),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
